import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getObjectives, createObjective } from "../../../_api/Talent";
import { getUsers } from "../../../_api/Admin";
import { Loader } from "../../../_helpers/components/Forms/Loader";

const STATUS_LABELS = { TODO: "À faire", IN_PROGRESS: "En cours", DONE: "Terminé" };

const formatDate = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "");

export const Objectifs = () => {
    const [objectives, setObjectives] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [form, setForm] = useState({ title: "", description: "", due_date: "", user_id: "" });

    const fetch = () => {
        setLoading(true);
        Promise.all([getObjectives(), getUsers()])
            .then(([oRes, uRes]) => {
                setObjectives(oRes.data || []);
                setUsers(uRes.data || []);
            })
            .catch((err) => setError(err?.response?.data?.message || "Erreur"))
            .finally(() => setLoading(false));
    };

    useEffect(() => fetch(), []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!form.title.trim() || !form.user_id) return;
        createObjective({
            ...form,
            user_id: form.user_id,
            due_date: form.due_date || undefined,
        })
            .then(() => {
                toast.success("Objectif créé.");
                setForm({ title: "", description: "", due_date: "", user_id: "" });
                fetch();
            })
            .catch((err) => toast.error(err?.response?.data?.message || "Erreur"));
    };

    if (loading) return <Loader text="Chargement..." />;
    if (error) return <div className="p-6 text-red-600">{error}</div>;

    return (
        <div className="p-6 space-y-6">
            <h1 className="text-2xl font-bold">Gestion des Objectifs</h1>

            <div className="bg-white shadow-sm rounded-xl p-4">
                <h2 className="text-lg font-semibold mb-4">Objectifs</h2>
                {objectives.length > 0 ? (
                    <ul className="space-y-3">
                        {objectives.map((o) => (
                            <li key={o.id} className="border-b pb-3">
                                <p className="font-medium">{o.title}</p>
                                {o.description && <p className="text-sm text-gray-600">{o.description}</p>}
                                <p className="text-sm text-gray-600">Collaborateur : {o.user?.first_name} {o.user?.last_name}</p>
                                <p className="text-sm text-gray-600">Échéance : {formatDate(o.due_date)} | {STATUS_LABELS[o.status] || o.status}</p>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-sm text-gray-500">Aucun objectif</p>
                )}
            </div>

            <div className="bg-white shadow-sm rounded-xl p-4">
                <h2 className="text-lg font-semibold mb-4">Nouvel objectif</h2>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Titre</label>
                        <input type="text" value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} className="mt-1 w-full px-4 py-2 border rounded" required placeholder="Titre de l'objectif" />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea value={form.description} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} className="mt-1 w-full px-4 py-2 border rounded" rows={3} />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Collaborateur</label>
                        <select value={form.user_id} onChange={(e) => setForm((f) => ({ ...f, user_id: e.target.value }))} className="mt-1 w-full px-4 py-2 border rounded" required>
                            <option value="">—</option>
                            {users.filter((u) => u.activated !== false).map((u) => (
                                <option key={u.id} value={u.id}>{u.first_name} {u.last_name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Échéance</label>
                        <input type="date" value={form.due_date} onChange={(e) => setForm((f) => ({ ...f, due_date: e.target.value }))} className="mt-1 w-full px-4 py-2 border rounded" />
                    </div>
                    <button type="submit" className="px-4 py-2 bg-app-primary text-white rounded">Ajouter</button>
                </form>
            </div>
        </div>
    );
};
